export default "__VITE_ASSET__Cnq0Llt5__"